export default [
  "$analyticsProvider",
  "$stateProvider",
  "$urlRouterProvider",
  "$ocLazyLoadProvider",
  "$httpProvider",
  "RestangularProvider",
  "$animateProvider",
  "$injector",
  "$provide",
  "toastrConfig",
  function config(
    $analyticsProvider,
    $stateProvider,
    $urlRouterProvider,
    $ocLazyLoadProvider,
    $httpProvider,
    RestangularProvider,
    $animateProvider,
    $injector,
    $provide,
    toastrConfig
  ) {
    var options = {
      allowHtml: true,
    };

    angular.extend(toastrConfig, options);
    //tmhDynamicLocaleProvider.localeLocationPattern('/{{locale}}/formats');

    // turn off automatic tracking
    $analyticsProvider.virtualPageviews(false);
    $analyticsProvider.firstPageview(false);
    $analyticsProvider.trackRoutes(false);
    $analyticsProvider.trackStates(false);

    $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);

    $urlRouterProvider.otherwise(function ($injector, $location) {
      var $state = $injector.get("$state");
      var $window = $injector.get("$window");

      var browserLanguage =
        $window.navigator.language || $window.navigator.userLanguage;

      $state.go("login", {
        locale: $state.$stateParams
          ? $state.$stateParams.locale
          : browserLanguage,
      });
    });

    $ocLazyLoadProvider.config({
      debug: false,
    });

    $httpProvider.defaults.withCredentials = true;
    $httpProvider.interceptors.push("httpCanceler");
    $httpProvider.interceptors.push("httpInterceptor");

    RestangularProvider.addFullRequestInterceptor(function (
      element,
      operation,
      what,
      url,
      headers,
      params,
      httpConfig
    ) {
      params.$t = moment(new Date()).format("x");

      httpConfig.maintenanceSwitch = true;

      var result = {
        params: params,
        httpConfig: httpConfig,
      };
      return result;
    });

    // add a response intereceptor
    RestangularProvider.addResponseInterceptor(function (
      data,
      operation,
      what,
      url,
      response,
      deferred
    ) {
      var extractedData;
      // .. to look for getList operations
      if (operation === "getList") {
        // .. and handle the data and meta data
        if (data.data !== undefined) {
          extractedData = data.data;
          extractedData.metadata = data.metadata;
        } else {
          extractedData = data;
          extractedData.metadata = {
            count: data.length,
          };
        }
      } else {
        extractedData = data;
      }
      return extractedData;
    });

    RestangularProvider.setErrorInterceptor(function (
      response,
      deferred,
      responseHandler
    ) {
      //console.log("response :", response.config.url, response.config.timeout.isGloballyCanceled,response.status);
      if (
        response.status === -1 &&
        response &&
        response.config &&
        response.config.timeout &&
        response.config.timeout.isGloballyCanceled === true
      ) {
        //console.log("global canceled request");
        return false; // error handled
      }
      return true; // error not handled
    });

    /* cookiesProvider.useDefaults({
     path: '/',
     domain: '.airplus.at',
     maxAge: 24*60*60
     }); */
  },
];



// WEBPACK FOOTER //
// ./src/ui/app/app.config.js